import {Head, Link, router, usePage} from '@inertiajs/react'
import Layout from "../../components/layout";
import {ArrowLeftIcon,} from "@heroicons/react/24/outline";
import Album from '../../components/album.jsx';
import React, {useCallback, useEffect, useState} from 'react';
import AuthForm from '../../components/authForm.jsx';
import {Modal} from 'react-responsive-modal';
import {Trans, useTranslation} from 'react-i18next';

export default function PhotosIndex({
                                        event,
                                        photos,
                                        backUrl,
                                        aspectRatio,
                                        effects,
                                        currentEffect,
                                        uploadUrl,
                                        allowBack,
                                        reloadUrl,
                                        has_account
                                    }) {
    const {t} = useTranslation();
    const [effect, setEffect] = useState(currentEffect);
    const {url: currentUrl} = usePage()
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!has_account) {
            setOpen(true);
        }
    }, []);

    const onEffectChange = useCallback((e) => {
        const value = e.target.value;
        setEffect(value);
        const url = new URL(currentUrl, window.location);
        url.searchParams.set('effect_id', value);
        router.visit(url.toString(), {
            only: ['photos'],
            preserveScroll: true,
            preserveState: true,
        })
    }, []);

    const reveal = event.reveal_at_formatted;

    return (
        <Layout>
            <Head title={event.name + ' - Camera'} />
            <div className="flex flex-col px-5 grow h-full">
                {(event.reveal_type === 'after' || event.reveal_type === 'during') && !has_account && !event.can_view_photos &&
                    <Modal open={open} onClose={() => setOpen(false)} center>
                        <AuthForm isAfter={event.reveal_type === 'after'} event={event} />
                    </Modal>}

                <div className="sticky top-0 z-10 pt-5 backdrop-blur-sm">

                    <div className="flex items-center">
                        {allowBack && <Link href={backUrl}>
                            <div
                                className="flex-row mr-5 items-center  button-backdrop">
                                <ArrowLeftIcon className="w-[25px] h-[25px] text-white-foreground" />
                            </div>
                        </Link>}
                        <div>
                            <h1 className="text-white-foreground leading-tight text-xl md:text-3xl font-bold">{t('Album')}</h1>
                            <span className="text-white-foreground leading-tight">{event.name}</span>
                        </div>
                    </div>

                    <div className="mt-1">
                        <label htmlFor="effect" className="text-white-foreground">{t('Filter effect')}</label>
                        <select name="effect"
                                className="w-full mt-1 button-backdrop text-white-foreground"
                                onChange={onEffectChange} value={effect}>
                            {effects.map(e => <option key={e.value} value={e.value}>{e.label}</option>)}
                        </select>
                    </div>
                    <div className="flex text-center">
                        {uploadUrl &&
                            <a className="flex-wrap w-full shadow-sm transition duration-300 transform px-6 py-3 font-medium text-white-foreground mt-[10px] rounded-[10px] focus:outline-hidden hover:shadow-md bg-primary-500 hover:bg-primary-400"
                               href={uploadUrl}>{t('Upload your photos')}</a>}
                    </div>
                </div>

                <div className="flex grow w-full mb-5 mt-2">
                    {event.reveal_type === 'after' && !event.can_view_photos && <div
                        className="flex text-center flex-row items-center justify-center  button-backdrop w-full text-white-foreground">
                        <span><Trans i18nKey="revealComeBack">Photos will be revealed at <span
                            className="font-semibold">{{reveal}}</span>. Please come back then.</Trans></span>
                    </div>}
                    {event.reveal_type === 'hidden' && !event.is_organizer && <div
                        className="flex text-center flex-row items-center  button-backdrop text-white-foreground">
                        <h1>{t("The organizer of this event chose to hide other people's photos. You can only view your own photos.")}</h1>
                    </div>}
                </div>
                {event.can_view_photos &&
                    <Album slideshowAccess={event.live_slideshow_enabled} reloadUrl={reloadUrl} event={event}
                           aspectRatio={aspectRatio} photos={photos} />}
            </div>
        </Layout>
    )
}
